import React from 'react';
import { ShieldCheck, Sparkles, Target, Award } from 'lucide-react';
export function PolaGroupSection() {
  return <section className="py-24 bg-brand-bg/30" data-id="element-462">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-463">
        {/* Hero Banner Image */}
        <div className="max-w-6xl mx-auto mb-20" data-id="element-464">
          <div className="rounded-2xl overflow-hidden shadow-xl shadow-brand-copper/10 border border-brand-lightCopper/30 bg-white" data-id="element-465">
            <img src="https://cdn.magicpatterns.com/uploads/8W6KQRxcNxF7ie5kNGp3WL/About_Us.jpg" alt="Pola Group - ผู้นำเข้าและจัดจำหน่ายผลิตภัณฑ์การแพทย์และความงามจากต่างประเทศ" className="w-full h-auto object-cover" data-id="element-466" />
          </div>
        </div>

        {/* Header & Intro */}
        <div className="max-w-3xl mx-auto text-center mb-20" data-id="element-467">
          <h2 className="text-sm font-bold tracking-widest text-brand-copper uppercase mb-4" data-id="element-468">
            Pola Group
          </h2>
          <h3 className="text-3xl md:text-4xl font-light text-gray-900 mb-8 leading-tight" data-id="element-469">
            ผู้นำด้านนวัตกรรมความงาม
            <br data-id="element-470" />
            <span className="font-semibold" data-id="element-471">มาตรฐานสากลในประเทศไทย</span>
          </h3>
          <div className="space-y-6 text-gray-600 text-lg leading-relaxed" data-id="element-472">
            <p data-id="element-473">
              Singderm Thailand by Pola Group
              คือผู้นำเข้าและจัดจำหน่ายผลิตภัณฑ์ด้านความงามและนวัตกรรมทางการแพทย์อย่างเป็นทางการในประเทศไทย
              ภายใต้มาตรฐานการคัดเลือกผลิตภัณฑ์ระดับสากล
              เพื่อส่งมอบประสบการณ์ด้านความงามที่มีคุณภาพ ปลอดภัย
              และน่าเชื่อถือให้แก่คลินิก แพทย์ และผู้บริโภคยุคใหม่
            </p>
            <p data-id="element-474">
              ด้วยความเชี่ยวชาญในอุตสาหกรรม Medical Aesthetics
              บริษัทมุ่งมั่นในการคัดสรรนวัตกรรมที่ผ่านการรับรองมาตรฐานระดับโลก
              พร้อมสนับสนุนการดูแลผิวและความงามอย่างมีประสิทธิภาพในระยะยาว
              ภายใต้แนวคิดของการเป็น{' '}
              <span className="font-medium text-brand-darkCopper" data-id="element-475">
                "Trusted Partner"
              </span>{' '}
              สำหรับทั้งผู้เชี่ยวชาญด้านความงามและผู้เข้ารับบริการ
            </p>
          </div>
        </div>

        {/* Verifiable Standards - Highlight Card */}
        <div className="max-w-4xl mx-auto mb-20" data-id="element-476">
          <div className="bg-white rounded-2xl shadow-xl shadow-brand-copper/5 border border-brand-lightCopper/30 p-8 md:p-12 relative overflow-hidden" data-id="element-477">
            <div className="absolute top-0 right-0 w-64 h-64 bg-brand-lightCopper/20 rounded-full blur-3xl -mr-32 -mt-32" data-id="element-478"></div>

            <div className="relative z-10 flex flex-col md:flex-row items-start md:items-center gap-8" data-id="element-479">
              <div className="flex-shrink-0 bg-brand-copper/10 p-6 rounded-full" data-id="element-480">
                <ShieldCheck className="w-16 h-16 text-brand-copper" data-id="element-481" />
              </div>
              <div data-id="element-482">
                <h4 className="text-2xl font-semibold text-gray-900 mb-4" data-id="element-483">
                  มาตรฐานที่ตรวจสอบได้
                </h4>
                <p className="text-gray-600 mb-6 leading-relaxed" data-id="element-484">
                  ผลิตภัณฑ์ Singderm ที่นำเข้าโดย Pola Group
                  ได้รับการรับรองจากสำนักงานคณะกรรมการอาหารและยา (อย.)
                  อย่างถูกต้อง เพื่อสร้างความมั่นใจในด้านคุณภาพ ความปลอดภัย
                  และการตรวจสอบย้อนกลับได้ในทุกขั้นตอน
                </p>
                <div className="inline-flex items-center gap-3 bg-gray-50 border border-gray-200 rounded-lg px-6 py-4" data-id="element-485">
                  <span className="text-sm text-gray-500 font-medium uppercase tracking-wider" data-id="element-486">
                    เลขทะเบียน อย.
                  </span>
                  <span className="text-xl md:text-2xl font-mono font-bold text-brand-darkCopper tracking-wider" data-id="element-487">
                    68-2-1-2-0002371
                  </span>
                  <Award className="w-6 h-6 text-green-500 ml-2" data-id="element-488" />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Innovation & Vision Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-489">
          {/* Innovation */}
          <div className="bg-white p-10 rounded-2xl border border-gray-100 shadow-sm hover:shadow-md transition-shadow duration-300" data-id="element-490">
            <div className="w-12 h-12 bg-brand-copper/10 rounded-xl flex items-center justify-center mb-6" data-id="element-491">
              <Sparkles className="w-6 h-6 text-brand-copper" data-id="element-492" />
            </div>
            <h4 className="text-xl font-semibold text-gray-900 mb-4" data-id="element-493">
              นวัตกรรมเพื่อผลลัพธ์ที่เป็นธรรมชาติ
            </h4>
            <p className="text-gray-600 leading-relaxed" data-id="element-494">
              Singderm ถูกพัฒนาด้วยเทคโนโลยีการผลิตที่ทันสมัย
              ผ่านกระบวนการผลิตที่ได้รับมาตรฐานระดับสากล
              เพื่อสนับสนุนการดูแลผิวและการปรับรูปหน้าอย่างเป็นธรรมชาติ
              โดยคำนึงถึงทั้งประสิทธิภาพและความปลอดภัยควบคู่กัน
            </p>
          </div>

          {/* Vision */}
          <div className="bg-white p-10 rounded-2xl border border-gray-100 shadow-sm hover:shadow-md transition-shadow duration-300" data-id="element-495">
            <div className="w-12 h-12 bg-brand-copper/10 rounded-xl flex items-center justify-center mb-6" data-id="element-496">
              <Target className="w-6 h-6 text-brand-copper" data-id="element-497" />
            </div>
            <h4 className="text-xl font-semibold text-gray-900 mb-4" data-id="element-498">
              วิสัยทัศน์ของเรา
            </h4>
            <blockquote className="border-l-4 border-brand-copper pl-4 mb-4 italic text-gray-700 font-medium" data-id="element-499">
              "Pola Group เชื่อว่ามาตรฐานคือจุดเริ่มต้นของความงามอย่างยั่งยืน"
            </blockquote>
            <p className="text-gray-600 leading-relaxed" data-id="element-500">
              เราจึงเดินหน้าคัดสรรนวัตกรรมจากทั่วโลก
              เพื่อยกระดับวงการความงามในประเทศไทย พร้อมสร้างมาตรฐานด้านคุณภาพ
              ความน่าเชื่อถือ และประสบการณ์ที่ตอบโจทย์ผู้บริโภคยุคใหม่
            </p>
          </div>
        </div>
      </div>
    </section>;
}